/**
 * Work Order JTM Module
 * URLs injected via window.WorkOrderJtmConfig (PHP bridge).
 */
export function initWorkOrderJtm() {
  const cfg = window.WorkOrderJtmConfig || {};

  // ─── Map ────────────────────────────────────────────────────────────────
  let woMap = null;
  let woMarker = null;

  function initOrUpdateMap(lat, lng, label) {
    if (!lat || !lng) return;
    lat = parseFloat(lat);
    lng = parseFloat(lng);
    if (isNaN(lat) || isNaN(lng)) return;

    if (!woMap) {
      woMap = L.map('mapTemuan', { scrollWheelZoom: false }).setView([lat, lng], 16);
      L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        maxZoom: 22,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        attribution: 'Google Maps',
      }).addTo(woMap);
    } else {
      woMap.setView([lat, lng], 16);
    }
    if (woMarker) woMap.removeLayer(woMarker);

    const redIcon = L.icon({
      iconUrl:
        'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
      shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });
    woMarker = L.marker([lat, lng], { icon: redIcon })
      .addTo(woMap)
      .bindPopup(
        '<strong>' + label + '</strong><br>Koordinat: ' + lat.toFixed(6) + ', ' + lng.toFixed(6)
      )
      .openPopup();
    setTimeout(() => woMap.invalidateSize(), 300);
  }

  // ─── Search Inspeksi ────────────────────────────────────────────────────
  window.searchInspeksi = function searchInspeksi() {
    const kode = $('#kode_inspeksi').val().trim();
    if (!kode) {
      Swal.fire({
        icon: 'warning',
        title: 'Pencarian Kosong',
        text: 'Harap masukkan kode inspeksi temuan terlebih dahulu.',
        customClass: { confirmButton: 'btn btn-primary rounded-pill px-4' },
        buttonsStyling: false,
      });
      return;
    }

    const $btn = $('#btnSearch');
    const orig = $btn.html();
    $btn
      .html('<span class="spinner-border spinner-border-sm" role="status"></span> Mencari...')
      .prop('disabled', true);

    const noImg =
      "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'><rect width='400' height='300' fill='%23f8f9fa'/><text x='200' y='165' font-family='system-ui' font-size='14' font-weight='600' fill='%236c757d' text-anchor='middle'>Tidak Ada Foto</text></svg>";

    $.ajax({
      url: cfg.urlSearch,
      type: 'GET',
      data: { kode_inspeksi: kode },
      success(response) {
        $btn.html(orig).prop('disabled', false);
        if (response.status === 'success') {
          const d = response.data;
          $('#id_inspeksi').val(d.id_inspeksi);
          $('#id_kategori_asset')
            .val(d.id_kategori_asset || '')
            .trigger('change');
          $('#lbl_up3').text(d.nama_up3 || '-');
          $('#lbl_ulp').text(d.nama_ulp || '-');
          $('#lbl_penyulang').text(d.nama_penyulang || '-');
          $('#lbl_tiang').text(d.nomor_tiang ? `${d.kode_tiang} (${d.nomor_tiang})` : d.kode_tiang);
          $('#lbl_komponen').text(d.nama_komponen || '-');
          $('#lbl_kondisi').text(d.nama_kondisi || '-');
          $('#wo_komponen').val(d.nama_komponen || '-');
          $('#wo_kondisi').val(d.nama_kondisi || '-');

          $('#img_temuan').attr(
            'src',
            d.foto_temuan ? cfg.urlInspeksiImage + d.foto_temuan : noImg
          );
          $('#img_pendukung').attr(
            'src',
            d.foto_pendukung ? cfg.urlInspeksiImage + d.foto_pendukung : noImg
          );

          if (d.id_ulp) {
            $.ajax({
              url: cfg.urlPegawaiByUlp,
              type: 'GET',
              data: { id_ulp: d.id_ulp },
              success(res) {
                const $sel = $('#id_pegawai');
                $sel.empty().append('<option value="">-- Pilih Petugas --</option>');
                if (res.data && res.data.length > 0) {
                  res.data.forEach((p) =>
                    $sel.append(`<option value="${p.id_pegawai}">${p.nama_pegawai}</option>`)
                  );
                } else {
                  $sel.append('<option value="" disabled>Tidak ada petugas di ULP ini</option>');
                }
                $sel.trigger('change');
              },
            });
          }

          $('#woContainer')
            .removeClass('d-none')
            .hide()
            .fadeIn(400, function () {
              const label = d.nomor_tiang
                ? `${d.kode_tiang} (${d.nomor_tiang})`
                : d.kode_tiang || 'Lokasi Temuan';
              $('#lbl_lat').text(d.latitude || '-');
              $('#lbl_lng').text(d.longitude || '-');
              initOrUpdateMap(d.latitude, d.longitude, label);
            });

          $('html, body').animate({ scrollTop: $('#woContainer').offset().top - 100 }, 500);
        }
      },
      error(xhr) {
        $btn.html(orig).prop('disabled', false);
        $('#woContainer').addClass('d-none');
        const msg = xhr.responseJSON?.message || 'Terjadi kesalahan saat mencari data.';
        Swal.fire({
          icon: 'error',
          title: 'Pencarian Gagal',
          text: msg,
          customClass: { confirmButton: 'btn btn-primary rounded-pill px-4' },
          buttonsStyling: false,
        });
      },
    });
  };

  // ─── WhatsApp Link Builder ───────────────────────────────────────────────
  function getWhatsAppLink(row) {
    const mapsLink =
      row.tiang_latitude && row.tiang_longitude
        ? `https://www.google.com/maps/search/?api=1&query=${row.tiang_latitude},${row.tiang_longitude}`
        : '-';

    const text = encodeURIComponent(
      `*WORK ORDER*\n\n` +
        `Tanggal : ${row.created_at ? new Date(row.created_at).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) : '-'}\n` +
        `ID Work Order : ${row.kode_eksekusi_jtm || '-'}\n` +
        `UP3 : ${row.nama_up3 || '-'}\n` +
        `ULP : ${row.nama_ulp || '-'}\n` +
        `Penyulang : ${row.nama_penyulang || '-'}\n` +
        `Temuan : ${row.nama_komponen || '-'}\n` +
        `Kondisi : ${row.nama_kondisi || '-'}\n` +
        `Skala Prioritas : ${row.kategori_asset || '-'}\n` +
        `Target Pelaksanaan : ${row.tanggal ? new Date(row.tanggal).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) : '-'}\n` +
        `Keterangan : ${row.keterangan || '-'}\n\n` +
        `Maps :\n${mapsLink}\n\n` +
        `Mohon segera ditindaklanjuti dan dilaporkan setelah selesai. Terima kasih.`
    );
    let phone = (row.nomor_hp || '').replace(/\D/g, '');
    if (phone.startsWith('0')) phone = '62' + phone.substring(1);
    return phone
      ? `https://wa.me/${phone}?text=${text}`
      : `https://api.whatsapp.com/send?text=${text}`;
  }

  // ─── Show WO Detail Modal ───────────────────────────────────────────────
  window.showWoDetail = function showWoDetail(id) {
    $('#woDetailLoader').removeClass('d-none');
    $('#woDetailBody').addClass('d-none');
    $('#modalDetailWO').modal('show');

    $.ajax({
      url: cfg.urlDetail + '/' + id,
      type: 'GET',
      success(response) {
        if (response.status === 'success') {
          const d = response.data;
          $('#det_kode_wo').text(d.kode_eksekusi_jtm || '-');
          $('#det_kategori').text(d.kategori_asset || 'JTM');
          $('#det_pelaksana_tipe').text(d.pelaksana_tipe || '-');
          $('#det_pelaksana').text(
            d.pelaksana_tipe === 'TIM'
              ? 'Tim ' + (d.pelaksana_tim || '-')
              : `${d.nama_pegawai || '-'} (NIP: ${d.nip || '-'})`
          );
          $('#det_tanggal_target').text(d.tanggal_target_formatted || '-');
          $('#det_tanggal_batas').text(d.tanggal_batas_formatted || '-');

          let cls = 'bg-info text-white';
          if (d.status === 'SELESAI') cls = 'bg-success text-white';
          else if (d.status === 'DITUGASKAN') cls = 'bg-warning text-dark';
          $('#det_status')
            .text(d.status || '-')
            .attr('class', 'badge px-3 py-1 rounded-pill ' + cls);

          $('#det_kode_inspeksi').text(d.kode_inspeksi || '-');
          $('#det_tanggal_inspeksi').text(d.tanggal_inspeksi_formatted || '-');
          $('#det_komponen').text(d.nama_komponen || '-');
          $('#det_kondisi').text(d.nama_kondisi || '-');
          $('#det_up3').text(d.nama_up3 || '-');
          $('#det_ulp').text('ULP ' + (d.nama_ulp || '-'));
          $('#det_penyulang').text(d.nama_penyulang || '-');
          $('#det_tiang').text(
            'Tiang ' + (d.kode_tiang || '-') + ' / No. ' + (d.nomor_tiang || '-')
          );

          if (d.tiang_latitude && d.tiang_longitude) {
            $('#det_koordinat').text(
              parseFloat(d.tiang_latitude).toFixed(6) +
                ', ' +
                parseFloat(d.tiang_longitude).toFixed(6)
            );
            $('#det_map_link')
              .attr(
                'href',
                `https://www.google.com/maps/search/?api=1&query=${d.tiang_latitude},${d.tiang_longitude}`
              )
              .show();
          } else {
            $('#det_koordinat').text('-');
            $('#det_map_link').hide();
          }

          $('#det_catatan').text(d.keterangan || 'Tidak ada catatan tambahan.');
          $('#det_btn_print').attr('href', cfg.urlPrint + '/' + id);

          $('#woDetailLoader').addClass('d-none');
          $('#woDetailBody').removeClass('d-none');
        }
      },
      error(xhr) {
        $('#modalDetailWO').modal('hide');
        Swal.fire({
          icon: 'error',
          title: 'Kesalahan',
          text: xhr.responseJSON?.message || 'Gagal mengambil detail Work Order.',
          customClass: { confirmButton: 'btn btn-primary rounded-pill px-4' },
          buttonsStyling: false,
        });
      },
    });
  };

  // ─── Cancel WO ──────────────────────────────────────────────────────────
  window.cancelWorkOrder = function cancelWorkOrder(id) {
    Swal.fire({
      title: 'Batalkan Work Order?',
      text: 'Status temuan inspeksi akan dikembalikan menjadi TEMUAN agar bisa diproses ulang.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ya, Batalkan!',
      cancelButtonText: 'Batal',
      customClass: {
        confirmButton: 'btn btn-danger rounded-pill px-4 me-2',
        cancelButton: 'btn btn-light rounded-pill px-4',
      },
      buttonsStyling: false,
    }).then((result) => {
      if (!result.isConfirmed) return;
      Swal.fire({ title: 'Memproses...', didOpen: () => Swal.showLoading() });
      $.ajax({
        url: cfg.urlCancel + '/' + id,
        type: 'POST',
        success(res) {
          Swal.fire({
            icon: 'success',
            title: 'Berhasil!',
            text: res.message,
            customClass: { confirmButton: 'btn btn-primary rounded-pill px-4' },
            buttonsStyling: false,
          }).then(() => {
            if (window.woTable) window.woTable.ajax.reload();
          });
        },
        error(xhr) {
          Swal.fire({
            icon: 'error',
            title: 'Gagal',
            text: xhr.responseJSON?.message || 'Terjadi kesalahan sistem.',
            customClass: { confirmButton: 'btn btn-primary rounded-pill px-4' },
            buttonsStyling: false,
          });
        },
      });
    });
  };

  // ─── Eskalasi WO ─────────────────────────────────────────────────────────
  window.showEskalasiModal = function (id) {
    $('#eskalasi_id_eksekusi').val(id);
    $('#formEskalasi')[0].reset();
    $('#modalEskalasi').modal('show');
  };

  $('#formEskalasi').on('submit', function (e) {
    e.preventDefault();
    const data = $(this).serialize();

    Swal.fire({
      title: 'Meneruskan Work Order?',
      text: 'WO ini akan diteruskan ke tim lain. WO JTM Anda akan tetap tercatat sebagai KENDALA dengan tambahan catatan ini.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ya, Eskalasi!',
      cancelButtonText: 'Batal',
      customClass: {
        confirmButton: 'btn btn-warning rounded-pill px-4 me-2 text-dark fw-bold',
        cancelButton: 'btn btn-light rounded-pill px-4',
      },
      buttonsStyling: false,
    }).then((result) => {
      if (!result.isConfirmed) return;

      Swal.fire({
        title: 'Memproses Eskalasi...',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      $.ajax({
        url: cfg.urlEscalate,
        type: 'POST',
        data: data + '&' + cfg.csrfToken + '=' + cfg.csrfHash,
        success(res) {
          if (res.status === 'success') {
            Swal.fire({
              icon: 'success',
              title: 'Berhasil!',
              text: res.message,
              customClass: { confirmButton: 'btn btn-primary rounded-pill px-4' },
              buttonsStyling: false,
            }).then(() => {
              $('#modalEskalasi').modal('hide');
              if (window.woTable) window.woTable.ajax.reload();
            });
          }
        },
        error(xhr) {
          Swal.fire({
            icon: 'error',
            title: 'Gagal',
            text: xhr.responseJSON?.message || 'Terjadi kesalahan sistem.',
            customClass: { confirmButton: 'btn btn-primary rounded-pill px-4' },
            buttonsStyling: false,
          });
        },
      });
    });
  });

  // ─── Dashboard Counts ──────────────────────────────────────────────────
  function updateDashboardCounts(counts) {
    if (!counts) return;
    $('#count-total-wo').text(new Intl.NumberFormat('id-ID').format(counts.total || 0));
    $('#count-ditugaskan-wo').text(new Intl.NumberFormat('id-ID').format(counts.ditugaskan || 0));
    $('#count-waiting-wo').text(new Intl.NumberFormat('id-ID').format(counts.waiting || 0));
    $('#count-selesai-wo').text(new Intl.NumberFormat('id-ID').format(counts.selesai || 0));
    $('#count-terlambat-wo').text(new Intl.NumberFormat('id-ID').format(counts.terlambat || 0));
  }
  window.updateDashboardCounts = updateDashboardCounts;

  // ─── Filter Form ─────────────────────────────────────────────────────────
  window._woFilterQuery = cfg.filterQuery || '';

  $('#woFilterForm').on('submit', function (e) {
    e.preventDefault();
    const params = $(this).serialize();
    window._woFilterQuery = params ? '?' + params : '';
    const initUrl = params ? cfg.urlInitExport + '?' + params : cfg.urlInitExport + '?';
    const chunkUrl = params ? cfg.urlExportChunk + '?' + params : cfg.urlExportChunk + '?';
    $('#linkExcelWo').attr('data-url-init', initUrl).attr('data-url-chunk', chunkUrl);
    $('#linkExcelWoPhoto')
      .attr('data-url-init', initUrl + '&with_photo=1')
      .attr('data-url-chunk', chunkUrl + '&with_photo=1');
    if (window.woTable) {
      window.woTable.ajax.reload();
    }
  });

  // ─── DataTable ───────────────────────────────────────────────────────────
  $(document).ready(function () {
    const woTable = (window.woTable = $('#tableWoHistory').DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: cfg.urlHistory,
        type: 'GET',
        data: function (d) {
          const formParams = $('#woFilterForm').serializeArray();
          formParams.forEach((item) => {
            if (item.value) {
              if (d[item.name]) {
                if (!Array.isArray(d[item.name])) {
                  d[item.name] = [d[item.name]];
                }
                d[item.name].push(item.value);
              } else {
                d[item.name] = item.value;
              }
            }
          });
        },
        dataSrc(json) {
          if (json.dashboardCounts) {
            updateDashboardCounts(json.dashboardCounts);
          }
          return json.data || [];
        },
      },
      createdRow: function (row, data, dataIndex) {
        if (data.durasi_class === 'danger' && data.status !== 'SELESAI') {
          $(row).addClass('table-danger');
        }
      },
      columns: [
        {
          data: null,
          render: (d, t, row) =>
            `<div class="text-center"><input type="checkbox" class="form-check-input row-select" value="${row.id_eksekusi_jtm}"></div>`,
          className: 'text-center',
          orderable: false,
        },
        {
          data: null,
          render: (d, t, row) => {
            let eskalasiBtn = '';
            if (row.status === 'KENDALA') {
              eskalasiBtn = `<button class="btn-action bg-warning text-dark border-0 shadow-sm" onclick="window.showEskalasiModal('${row.id_eksekusi_jtm}')" title="Eskalasi Work Order"><i class="bi bi-arrow-up-right-square"></i></button>`;
            }
            const deleteForm =
              cfg.canDelete !== false
                ? `<form action="${cfg.urlDelete}/${row.id_eksekusi_jtm}" method="post" class="d-inline">${cfg.csrfField}<button type="button" class="btn-action btn-delete btn-delete-submit" title="Hapus Work Order"><i class="bi bi-trash"></i></button></form>`
                : '';
            const waBtn =
              cfg.canShareWhatsapp !== false
                ? `<a href="${getWhatsAppLink(row)}" target="_blank" class="btn-action btn-whatsapp" title="Kirim WhatsApp" style="background-color:#25D366!important"><i class="bi bi-whatsapp"></i></a>`
                : '';
            return `<div class="action-group justify-content-center">
                        ${eskalasiBtn}
                        <button class="btn-action btn-view" onclick="showWoDetail('${row.id_eksekusi_jtm}')" title="Detail Work Order"><i class="bi bi-eye"></i></button>
                        ${waBtn}
                        ${deleteForm}
                    </div>`;
          },
          orderable: false,
          className: 'text-center',
        },
        { data: 'kode_inspeksi', render: (d) => `<span class="fw-bold text-primary">${d}</span>` },
        {
          data: 'nomor_po',
          defaultContent: '-',
          render: (d) =>
            d
              ? `<span class="fw-medium text-dark">${d}</span>`
              : '<span class="text-muted">-</span>',
        },
        { data: 'nama_ulp', defaultContent: '-' },
        {
          data: null,
          render: (d, t, row) =>
            row.pelaksana_tipe === 'TIM'
              ? `<span class="fw-bold text-primary"><i class="bi bi-people-fill me-1"></i>Tim ${row.pelaksana_tim || '-'}</span>`
              : row.nama_pegawai
                ? `<span class="fw-medium text-dark"><i class="bi bi-person-fill me-1"></i>${row.nama_pegawai}</span>`
                : '-',
        },
        {
          data: 'status',
          render: (d) => {
            const cls =
              d === 'SELESAI'
                ? 'bg-success text-white'
                : d === 'DITUGASKAN'
                  ? 'bg-warning text-dark'
                  : d === 'KENDALA'
                    ? 'bg-danger text-white'
                    : 'bg-info text-white';
            return `<span class="badge rounded-pill ${cls} px-3">${d}</span>`;
          },
        },
        {
          data: 'kategori_asset',
          defaultContent: '-',
          render: (d) =>
            d ? `<span class="badge bg-light text-dark border fw-bold px-2 py-1">${d}</span>` : '-',
        },
        { data: 'nama_komponen', defaultContent: '-' },
        {
          data: 'nama_kondisi',
          render: (d) => (d ? `<span class="text-danger fw-bold">${d}</span>` : '-'),
        },
        {
          data: 'tanggal',
          render: (d) =>
            d
              ? new Date(d).toLocaleDateString('id-ID', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                })
              : '-',
        },
        {
          data: null,
          render: (d, t, row) => {
            const cls =
              row.durasi_class === 'danger'
                ? 'bg-danger-subtle text-danger-emphasis border border-danger-subtle'
                : row.durasi_class === 'warning'
                  ? 'bg-warning-subtle text-warning-emphasis border border-warning-subtle'
                  : 'bg-success-subtle text-success-emphasis border border-success-subtle';
            return `<div class="d-flex flex-column gap-1" style="font-size:0.78rem">
                        <div class="d-flex align-items-center gap-1"><span class="text-muted text-uppercase fw-bold" style="font-size:0.65rem;width:50px">Target:</span><span class="badge bg-light text-dark border fw-bold px-2">${row.durasi_rencana || 0} Hari</span></div>
                        <div class="d-flex align-items-center gap-1"><span class="text-muted text-uppercase fw-bold" style="font-size:0.65rem;width:50px">Durasi:</span><span class="badge fw-bold px-2 ${cls}">${row.durasi_label || '-'}</span></div>
                    </div>`;
          },
        },
        {
          data: 'keterangan',
          defaultContent: '-',
          render: (d) =>
            d ? `<span class="text-muted small">${d}</span>` : '<span class="text-muted">-</span>',
        },
      ],
      order: [[10, 'desc']],
      autoWidth: false,
      scrollX: false,
      dom: "t<'row mt-4 align-items-center'<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0'i><'col-sm-12 col-md-7 d-flex justify-content-center justify-content-md-end'p>>",
      language: {
        search: '',
        lengthMenu: '_MENU_',
        info: "<span class='text-muted fw-medium small'>Menampilkan <b class='text-dark'>_START_-_END_</b> dari <b class='text-dark'>_TOTAL_</b></span>",
        infoEmpty: "<span class='text-muted small'>Menampilkan 0 data</span>",
        infoFiltered: "<span class='text-muted small'>(disaring dari _MAX_ data)</span>",
        emptyTable:
          "<div class='text-center py-4 text-muted'><i class='bi bi-inbox fs-4 d-block mb-2'></i>Belum ada Work Order yang diterbitkan</div>",
        zeroRecords:
          "<div class='text-center py-4 text-muted'><i class='bi bi-search fs-4 d-block mb-2'></i>Pencarian tidak ditemukan</div>",
        paginate: { previous: 'Sebelumnya', next: 'Berikutnya' },
        processing:
          '<div class="dt-loader-container"><div class="dt-loader-spinner"><div class="spinner-border text-primary" role="status"></div></div><div class="dt-loader-text">Memuat Data...</div></div>',
      },
      pageLength: 50,
    }));

    window.woTable = woTable;

    // Wire custom Show/Search controls to DataTable
    $('#woLengthMenu').on('change', function () {
      woTable.page.len(parseInt($(this).val())).draw();
    });
    let woSearchTimer;
    $('#woSearchInput').on('input', function () {
      const val = $(this).val();
      clearTimeout(woSearchTimer);
      woSearchTimer = setTimeout(() => woTable.search(val).draw(), 300);
    });

    if (cfg.canDelete === false) {
      woTable.column(0).visible(false);
    }

    // Duration calculator
    function updateDuration() {
      const t = $('[name="tanggal_target"]').val(),
        b = $('#tanggal_batas').val();
      if (t && b) {
        const diff = Math.ceil((new Date(b) - new Date(t)) / 86400000);
        $('#wo_durasi_rencana').val(diff >= 0 ? diff + ' Hari' : '0 Hari (Batas melewati target)');
      }
    }
    $('[name="tanggal_target"], #tanggal_batas').on('change', updateDuration);
    updateDuration();

    // Pelaksana type toggle
    $('#pelaksana_tipe').on('change', function () {
      if ($(this).val() === 'PETUGAS') {
        $('#container_petugas').removeClass('d-none');
        $('#id_pegawai').prop('required', true);
        $('#container_tim').addClass('d-none');
        $('#pelaksana_tim').prop('required', false).val('').trigger('change');
      } else {
        $('#container_tim').removeClass('d-none');
        $('#pelaksana_tim').prop('required', true);
        $('#container_petugas').addClass('d-none');
        $('#id_pegawai').prop('required', false).val('').trigger('change');
      }
    });

    // Form submit
    $('#formWorkOrder').on('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $form = $(this),
        $btn = $('#btnSubmitWO'),
        orig = $btn.html();
      Swal.fire({
        title: 'Terbitkan Work Order?',
        text: 'Tugas akan masuk ke antrean Eksekusi JTM untuk petugas terkait.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Ya, Terbitkan!',
        cancelButtonText: 'Batal',
        customClass: {
          confirmButton: 'btn btn-primary rounded-pill px-4 me-2',
          cancelButton: 'btn btn-light rounded-pill px-4',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (!result.isConfirmed) return;
        $btn
          .html('<span class="spinner-border spinner-border-sm"></span> Memproses...')
          .prop('disabled', true);
        $.ajax({
          url: $form.attr('action'),
          type: 'POST',
          data: $form.serialize(),
          success(res) {
            $btn.html(orig).prop('disabled', false);
            if (res.status === 'success') {
              Swal.fire({
                icon: 'success',
                title: 'Berhasil!',
                text: res.message,
                customClass: { confirmButton: 'btn btn-primary rounded-pill px-4' },
                buttonsStyling: false,
              }).then(() => {
                $form[0].reset();
                $('.select2').not('#pelaksana_tipe').val('').trigger('change');
                $('#pelaksana_tipe').val('PETUGAS').trigger('change');
                $('#kode_inspeksi').val('');
                $('#woContainer').fadeOut(() => $(this).addClass('d-none'));
                woTable.ajax.reload();
                $('html, body').animate({ scrollTop: 0 }, 500);
              });
            }
          },
          error(xhr) {
            $btn.html(orig).prop('disabled', false);
            Swal.fire({
              icon: 'error',
              title: 'Gagal',
              text: xhr.responseJSON?.message || 'Terjadi kesalahan sistem.',
              customClass: { confirmButton: 'btn btn-primary rounded-pill px-4' },
              buttonsStyling: false,
            });
          },
        });
      });
    });

    // Dashboard counts
    window.updateDashboardCounts = function (data) {
      let total = data.length,
        ditugaskan = 0,
        waiting = 0,
        selesai = 0,
        terlambat = 0;
      data.forEach((r) => {
        if (r.status === 'DITUGASKAN') ditugaskan++;
        else if (r.status === 'WAITING_APPROVAL') waiting++;
        else if (r.status === 'SELESAI') selesai++;

        if (r.durasi_class === 'danger' && r.status !== 'SELESAI') terlambat++;
      });
      $('#count-total-wo').text(total);
      $('#count-ditugaskan-wo').text(ditugaskan);
      $('#count-waiting-wo').text(waiting);
      $('#count-selesai-wo').text(selesai);
      $('#count-terlambat-wo').text(terlambat);
    };

    // Dashboard card filter clicks
    const cardFilters = {
      '#card-total': '',
      '#card-ditugaskan': 'DITUGASKAN',
      '#card-waiting': 'WAITING_APPROVAL',
      '#card-selesai': 'SELESAI',
    };
    Object.entries(cardFilters).forEach(([id, val]) => {
      $(id).on('click', function () {
        $('.dashboard-card').removeClass('active');
        $(this).addClass('active');
        const $sel = $('#tableWoHistory thead th').eq(6).find('select');
        if ($sel.length) {
          $sel.val(val).trigger('change');
        } else {
          val
            ? woTable
                .column(6)
                .search('^' + val + '$', true, false)
                .draw()
            : woTable.column(6).search('').draw();
        }
      });
    });
  });
}
